import type { SerializeFrom } from '~/types/serialize-from';
import { atom } from 'jotai';
import type { loader } from '~/routes/_app.search.$';

type SearchPageData = SerializeFrom<typeof loader>;

/**
 * Jotai atom to store the search page data fetched from the action.
 * This allows sharing the fetched data across different components on the search page
 * without prop drilling or re-fetching.
 */
export const searchPageDataAtom = atom<SearchPageData | null>(null);
